import React from 'react';
import { useNavigate } from 'react-router-dom';
import notFound from '../../images/404.png';

const NotFound = () => {
        const navigate = useNavigate();

        // Handle Routing Navigate:
        const handleRoute = () => {
                navigate('/');
        }
        return (
                <div className="brand-bg mt-5 pt-5">
                        <div className="container p-5 text-center">
                                <img src="https://cdn.dribbble.com/users/644529/screenshots/2662296/404.gif" className="img-fluid rounded-3" alt="" />
                        </div>
                        <div className="text-center">
                                <button onClick={handleRoute} className="btn brand-btn fw-bold" type="button">Back to Home</button>
                        </div>
                </div>
        );
};

export default NotFound;